import { DashboardModuleListItem, Image, SidebarModal } from '@domain-group/suit-theme'

import { CampaignModel } from '@models/campaign'

import placeholderImageUrl from '@assets/campaign_image_400x400.png'

interface CampaignSubHeaderProps {
  campaign: CampaignModel,
}

const CampaignSubHeader = (props: CampaignSubHeaderProps) => {
  const { campaign: { address, default_image, suburb_name } } = props

  return (
    <SidebarModal.SubHeader boxProps={{ padding: 'none' }}>
      <DashboardModuleListItem
        isSidebar
        imageComponent={(
          <Image
            borderRadius={5}
            height={65}
            placeholderUrl={placeholderImageUrl}
            url={default_image}
            width={100}
          />
        )}
        secondaryText={suburb_name}
        title={address}
      />
    </SidebarModal.SubHeader>
  )
}

export default CampaignSubHeader
